<template>
  <div id="root">
    <SogCard class="card">
      <SogCardTitle id="title">
        Detailansicht VB
        <SogIcon
          id="icon"
          :icon="rechercheMessage?.gdvMessageMode === 'Online' ? 'mdi-web' : 'mdi-database'"
        />
      </SogCardTitle>
      <slot />
      <SogCardContent id="content-container">
        <div id="label">
          VB-Nummer
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsbestaetigungsnummer"
        />

        <div id="label">
          VB-Status
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-start: 4; grid-column-end: span 5;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.vbStatusString"
        />

        <div id="label">
          VB-Einstelldatum
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.Date"
          :value="rechercheMessage?.vbEinstelldatum"
        />

        <div id="label">
          Nutzererkennungs
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.nutzerkennung"
        />
      </SogCardContent>
    </SogCard>

    <SogCard class="card">
      <SogCardTitle id="title">
        Versicherung
      </SogCardTitle>
      <SogCardContent id="content-container">
        <div id="label">
          Versicherer
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 5; grid-column-start: 2;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.name1"
        />

        <div id="label">
          Geschäftsstelle
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.geschaeftsstelleVersicherung"
        />

        <div id="label">
          GDV-Vermittler-ID
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.gdvVermittlernummer"
        />

        <div id="label">
          VB abrufbar bis
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.Date"
          :value="rechercheMessage?.vbAbrufbarBis"
        />

        <div id="label">
          Agentnummer
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.agenturVersicherung"
        />

        <div id="label">
          VU-interne Vermittlugnsnummer
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.vuInterneVermittlernummer"
        />

        <div id="label">
          Vers. Beginn
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.datumVersicherungsbeginn"
        />

        <div id="label">
          VB Art
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.vbArtDescription"
        /> <!-- vb art string gibt es nicht -->

        <div id="label">
          Zulassungsfahrten
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.zulassungsfahrten == '0' ? 'Nein' : 'Ja'"
        />

        <div id="label">
          Versicherungsscheinnr.
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.versicherungsscheinnummer"
        />

        <div id="label">
          Unternehmentsart
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-start: 2; grid-column-end: span 3;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.unternehmensartDescription"
        /> <!-- unternehmensart string gibt es nicht -->

        <div
          id="label"
          style="grid-row-start: 6;"
        >
          Int. Vermerke
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-start: 2; grid-column-end: span 5;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherung?.interneVermerkeVersicherung"
        />
      </SogCardContent>
    </SogCard>

    <SogCard class="card">
      <SogCardTitle id="title">
        Versicherungsnehmer
      </SogCardTitle>
      <SogCardContent id="content-container">
        <div id="label">
          Name Jur. Person
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 5; grid-column-start: 2;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.juristischePerson?.nameJuristischePerson "
        />

        <div id="label">
          Name Vereinigung
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 5; grid-column-start: 2;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.vereinigung?.nameVereinigung"
        />

        <div id="label">
          Name
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.natuerlichePerson?.nachname"
        />

        <div id="label">
          Akad. Grad
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
        /> <!-- nichts gefunden -->

        <div id="label">
          Postleitzahl
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.anschrift?.postleitzahl"
        />

        <div id="label">
          Namensbest.
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
        /> <!-- nichts gefunden -->

        <div id="label">
          Straße
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.anschrift?.strasse"
        />

        <div id="label">
          Wohnort
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.anschrift?.wohnort"
        />

        <div id="label">
          Vorname
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.natuerlichePerson?.vorname"
        />

        <div id="label">
          Hausnummer
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.anschrift?.hausnummer"
        />

        <div id="label">
          Staat
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.anschrift?.staat"
        />

        <div id="label">
          Geschlecht
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.natuerlichePerson?.geschlecht"
        />

        <div id="label">
          Adr. Zusatz
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.versicherungsnehmer?.anschrift?.adressierungszusaetze"
        />
      </SogCardContent>
    </SogCard>

    <SogCard class="card">
      <SogCardTitle id="title">
        Halter
      </SogCardTitle>
      <SogCardContent id="content-container">
        <div
          id="label"
          style="grid-column-end: span 3; grid-column-start: 0;"
        >
          Halter weicht vom Versicherungsnehmer
          ab?
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.halter?.halterAbweichendVonVersicherungsnehmer ? 'Ja' : 'Nein'"
        />
      </SogCardContent>
    </SogCard>

    <SogCard class="card">
      <SogCardTitle id="title">
        Kennzeichen
      </SogCardTitle>
      <SogCardContent id="content-container">
        <div id="label">
          Zulässige Kennzeichenarten
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 3; grid-column-start: 0;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.kennzeichen?.merkmalKennzeichenart"
        />

        <div id="label">
          Saisonende
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.kennzeichen?.kennzeichenString"
        />

        <div id="label">
          Kennzeichen
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.kennzeichen?.kennzeichenBisher"
        />

        <div id="label">
          Saisonbeginn
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.kennzeichen?.kennzeichenBisher"
        />

        <div id="label">
          Ablauftage Kurzz.
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.kennzeichen?.ablauftageKurzzeitkennzeichen"
        />

        <div id="label">
          Kennzeichen gültig bis
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.Date"
          :value="rechercheMessage?.kennzeichen?.datumKennzeichenGueltigBis"
        />
      </SogCardContent>
    </SogCard>

    <SogCard class="card">
      <SogCardTitle id="title">
        Fahrzeug
      </SogCardTitle>
      <SogCardContent id="content-container">
        <div id="label">
          FZ-Art
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.fahrzeug?.fahrzeugartDescription"
        />

        <div id="label">
          FIN
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 5; grid-column-start: 4;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.fahrzeug?.fahrzeugidentifizierungsnummer"
        />

        <div id="label">
          HSN
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.fahrzeug?.schluesselHersteller"
        /> <!-- unsicher -->

        <div id="label">
          Variante
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 5; grid-column-start: 4;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.fahrzeug?.schluesselVarianteVersion"
        /> <!-- unsicher -->

        <div id="label">
          TSN
        </div>
        <SogDataLabel
          class="value"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.fahrzeug?.schluesselTyp"
        /> <!-- unsicher -->

        <div id="label">
          Zulässige Verwendungszwecke
        </div>
        <SogDataLabel
          class="value"
          style="grid-column-end: span 5; grid-column-start: 4;"
          :value-type="SogDataLabelValueType.String"
          :value="rechercheMessage?.fahrzeug?.verwendungFahrzeug"
        />
      </SogCardContent>
    </SogCard>

    <SogCard class="card">
      <SogCardTitle id="title">
        Verarbeitungshistorie
      </SogCardTitle>
      <SogGrid
        :allow-filtering="true"
        :allow-paging="false"
        :columns="[
          {...DateTimeColumn, field: 'zeitpunktVerarbeitungsschritt', headerText: 'Zeitpunkt'},
          {...DefaultColumn, field: 'verarbeitungsschritt', headerText: 'Arbeitsschritt', width: '70%'},
          {...DefaultColumn, field: '', headerText: 'Detail'},
        ]"
        :data="rechercheMessage?.listeVbVerarbeitungshistorie"
      /> <!-- detail nicht gefunden -->
    </SogCard>
  </div>
</template>

<script setup lang="ts">


import SogGrid from '@/shared/ui/SogGrid.vue';


import SogCard from '@/shared/ui/SogCard.vue';
import SogCardContent from '@/shared/ui/SogCardContent.vue';
import SogCardTitle from '@/shared/ui/SogCardTitle.vue';

import RechercheMessage from '@/shared/model/RechercheMessage'

import SogDataLabel from '@/shared/ui/SogDataLabel.vue';
import {SogDataLabelValueType} from '@/shared/ui/types/SogDataLabelValueType'

import {DefaultColumn, DateTimeColumn} from '@/shared/ui/types/SogGridColumnDefinitions';

import SogIcon from '@/shared/ui/SogIcon.vue';

interface Props {
  rechercheMessage: RechercheMessage,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  rechercheMessage: undefined,
  messageMode: undefined,
})


</script>

<style scoped>

#root {
  width: 100%;
}

#icon {
  font-size: 32px;
}

#label {
  width: 100%;
}

.value {
  padding-left: 5px;
  border: 1px solid rgba(128, 128, 128, 0.584);
  border-radius: 5px;
  width: 100%;
  min-height: 30px;
  display: flex;
  align-items: center;
}

.card {
  width: 100%;
}


#content-container {
  place-items: center left;

  display: grid;
  width: 100%;
  grid-template-columns: 15% 15% 15% 15% 15% [end] 15%;
  gap: 10px;
}

@media screen and (max-width: 700px) {
  #content-container {
    display: flex;
    flex-direction: column;
  }

  .card {
    margin-bottom: 30px;
  }
}

</style>
